import React, { useState, useEffect } from 'react';
import { PlayerComponent } from '../sub-component';
import useScrollPosition from '@react-hook/window-scroll';
import axios from 'axios';
import spinner from '../../../assests/images/spinner.gif';
import alertBox from '../../../assests/images/alert_box.png';
import { IContentProps } from './content.types';

//const API = `https://epidemic-plugin-dot-ssemble-plugins-backend.uc.r.appspot.com`;

const API = `https://plugin-epidemic-api.ssemble.com`;

export const Content = (props: IContentProps) => {

  const { filter, filterCount, nextValue, setShowGenre, getSongData } = props;

  const [loading, setLoading] = useState(true);
  const [data, setData]: any = useState([]);
  const [next, setNext] = useState(nextValue);
  const [count, setCount] = useState(filterCount);
  const [currentFilter, setCurrentFilter] = useState('');
  const [nextLoad, setNextLoad] = useState(false);
  const scroll = useScrollPosition();
  const [downloading, setDownloading] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(`${API}/tracks?genre=${filter}`);
        if (response.tracks.links && response.tracks.links.next) {
          setNext(response.tracks.links.next);
        }
        setData(response.tracks.tracks);
      } catch (error) {
        //@ts-ignore
        console.error(error.message);
        const alterDiv = document.getElementById('alert_message');
          //@ts-ignore
          alterDiv.style.display = 'block'
            setTimeout(() => {
              //@ts-ignore
              alterDiv.style.display = 'none'
              window.location.reload();
            }, 1500)
      }
      setLoading(false);
    }

    if (filter !== currentFilter) {
      setCurrentFilter(filter);
      setNext('');
      setData([]);
      setCount(1);
      fetchData();
    }
  }, [loading, count, filter, currentFilter]);

  useEffect(() => {
    const loadMore = async () => {
      if (next && nextLoad === false) {
        setNextLoad(true)
        let cur_genre = next.split('?')[1];
        cur_genre = cur_genre.split('&')[0];
        let genre = cur_genre.replace('genre=', '')

        genre = genre.trim()
        if (filter === genre) {
          let options = next.split('?')[1]
          const { data: response } = await axios.get(`${API}/tracks?${options}`);
          if (next !== null) {
            const new_data: any = [...data, ...response.tracks.tracks];
            
            setData(new_data);
            setNext(response.tracks.links.next)
          }
        }
        setNextLoad(false)
      }
    }

    var totalPageHeight = document.body.scrollHeight;
    var scrollPoint = window.scrollY + window.innerHeight;
    let percentage = (scrollPoint / totalPageHeight) * 100;
    if (percentage >= 99.5) {
      loadMore()
    }

  }, [data, filter, next, nextLoad, scroll])

  const GetListData = () => {
    const elements = [];
    if (data) {
      for (const ele of data) {
        elements.push(<PlayerComponent key={ele.id} tracks={ele} setDownloading={setDownloading} setShowGenre={setShowGenre} getSongData={getSongData} />)
      }
    }
    return elements
  }

  const closeProgress = () => {
    setDownloading(false);
    setProgress(0);
    setShowGenre(true);
  }

  return (
    <div style={{ height: "100%" }}>
        <div id='alert_message' style={{ width: '150px', height: '35px', alignItems: 'center', display: 'none', zIndex: 999, marginTop: '17.2em', marginLeft: '8em', position : 'absolute'}}>
          <span style={{ fontSize: '15px', fontWeight: '400', fontFamily: 'Inter', color: '#FFFFFF', marginTop: '7px', position: 'fixed', marginLeft: '30px' }}>Please try again</span>
          <img src={alertBox} width='151px' height='35px' alt='Alert box' />
        </div>
      {downloading ? (
        <div style={{ width: '100%', height: '100%', marginTop: '30%', textAlign: 'center' }}>
          <p className={'heading'}>Importing </p>
          <p className={'sub-heading'}>Don't turn off the app or device.</p>
          <progress id="file" className="progress_bar" value={50} max="100"> </progress>
          <div>{progress !== 100 ? (<button className="cancel-button" type="reset" onClick={closeProgress}>Cancel</button>) : (<button className="cancel-button" type="reset" onClick={() => { }}>Cancel</button>)}</div>
        </div>
      ) : (loading === true ? (
        <div className='loader'
        >
          <img
            width='30px'
            height='auto'
            src={spinner}
            alt='loading...'
          />
        </div>
      ) : (
        <div className='display-100 content'>
          {GetListData()}
          {nextLoad === true ? (
            <div
              style={{
                width: '100%',
                height: 'auto',
                marginTop: '5px',
                zIndex: 102,
                textAlign: 'center',
              }}
            >
              <img
                width='30px'
                height='auto'
                src={spinner}
                alt='loading...'
              />
            </div>
          ) : (
            <div></div>
          )}
        </div>
      ))}
    </div>
  )
}

export default Content